import { RiRobot2Line } from "react-icons/ri";
import { LOCAL_IMAGE } from "../../../assets/images/ImagesJson";

export const SIDEBAR_ITEMS = [
  {
    key: "chat",
    title: "1CH Discover-Quick",
    icon: <RiRobot2Line className="me-2 " size={19} />,
    link: `/chat`,
  },
];
